import { gql } from '@apollo/client';

const SENT_DEVICE_PATIENT_RETURNED = gql`
  query sentDevicePatientReturned($deviceId: String!) {
    sentDevicePatientReturned(deviceId: $deviceId) {
      id
      study {
        id
        info {
          interprettingPhysician {
            id
          }
        }
      }
    }
  }
`;

export default SENT_DEVICE_PATIENT_RETURNED;
